// Shared by the speculative preload and React.lazy. Keep the import deferred;
// the browser/module loader deduplicates concurrent imports of this module.
type LoginPage = typeof import('../pages/Login');
let loadedLoginPage: LoginPage['default'] | undefined;

export const loadLoginPage = () => import('../pages/Login').then((module) => {
  loadedLoginPage = module.default;
  return module;
});

export const getLoadedLoginPage = () => loadedLoginPage;
